<template>
    <v-container fluid>
        <v-row>
            <v-col>
                <h4 class="text-h4">{{$t('edit_vehicle_type')}}</h4>
                <p class="text-subtitle">{{$t('edit_vehicle_form')}}</p>
            </v-col>
        </v-row>
        <v-divider></v-divider>
        <v-row class="mt-2">
            <v-col cols="12" md="6">
                <VehicleUsageForm v-if="!loading" v-model="form" ref="form"/>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" md="3">
                <v-btn color="primary" block @click="handleSave" :loading="loading">
                    <v-icon left>mdi-content-save</v-icon>
                    {{$t('save')}}
                </v-btn>
            </v-col>
            <v-col cols="12" md="3" @click="handleCancel">
                <v-btn depressed block>
                    {{$t('cancel')}}
                </v-btn>
            </v-col>
        </v-row>
        <PAlert v-model="alert.model" v-bind="alert"/>
    </v-container>
</template>

<script>
import VehicleUsageForm from './../../components/fleet/VehicleUsageForm.vue';
import service from './../../services/fleet/vehicleUsage';
import PAlert from './../../components/common/PAlert.vue';

export default {
    components: {
        VehicleUsageForm,
        PAlert
    },
    data() {
        return {
            form: {
                name: ""
            },
            loading: false,
            alert: {
                title: this.$t("alert_title"),
                content: "",
                callback: null,
                model: false
            },
            id: null
        }
    },
    methods: {
        fetchVehicleUsage() {
            this.loading = true;
            service.get(this.id).then(response => {
                let data = response.data;
                this.form = {...data}; 
            }).finally(() => {
                this.loading = false;
            })
        },
        handleSave() {
            this.alert = {...this.alert, model: true, content: this.$t("are_you_sure_you_want_to_save"), callback: this.save}
        },
        save() {
            if(!this.$refs.form.validate()) return;
            this.loading = true;
            service.update(this.id, this.form).then(response => {
                this.$router.replace({ name: "VehicleUsageDisplay", params: { vehicleUsageID: response.data.id } })
            }).finally(() => {
                this.loading = false;
            })
        },
        handleCancel() {
            this.alert = {...this.alert, model: true, content: this.$t("are_you_sure_cancel"), callback: this.cancel}
        },
        cancel() {
            this.$router.back();
        }
    },
    created() {
        this.id = this.$route.params.vehicleUsageID;
        this.fetchVehicleUsage()
    }
}
</script>

<style>

</style>